import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heading, Button } from 'glic-ui-components';
import 'glic-design-foundations/dist/design-foundations-classes.min.css';

import error from '../../assets/error.svg';

import './Error.scss';

const Error = () => {
  const history = useNavigate();

  const handleOnSubmit = () => {
    history('/');
  };
  return (
    <div className="warning-body">
      <div className="warning-title">
        <Heading h1 largeTitle>
          We'll be back soon!
        </Heading>
      </div>
      <img src={error} alt="" />
      <div className="warning-content">
        <p>
          The site is currently unavailable. Thank you for your patience while
          we get things going again. Please check back to continue with the
          process.
        </p>
      </div>
      {(
        <Button
          type="outlined"
          size="small"
          className="home-button"
          id="home"
          // eslint-disable-next-line react/jsx-no-bind
          onClick={handleOnSubmit}
        >
         Click here to go back
        </Button>
      )}
    </div>
  );
};

export default Error;
